<script setup>
import { onMounted } from 'vue';
import { useSettingsStore } from './stores/settings';
import Notice from '../Notice.vue';
import Navigation from '../settings/components/Navigation.vue';
const settingsStore = useSettingsStore();

const { labels } = window.DATAGENT_PLUGIN_SETTINGS;

onMounted(() => {
  settingsStore.loadSettings();
});
</script>

<template>
  <div class="dataagent-settings da:pr-4">
    <div class="da:flex da:items-center da:space-x-3">
      <h1 class="da:text-lg da:text-gray-800">
        <span>{{ labels.settings }}</span>
      </h1>
    </div>

    <div class="da:bg-white da:border-2 da:border-gray-200 da:rounded-lg da:shadow-sm">
      <!-- Notification area -->
      <Notice />

      <!-- Navigation Component with Tabs -->
      <Navigation />
    </div>
  </div>
</template>
